import { reportGlobalSalesTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_GLOBAL_SALES_FILTERS, RESTORE_INITIAL } = reportGlobalSalesTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportGlobalSalesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_GLOBAL_SALES_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState
    default:
      return state;
  }
};